import { render, staticRenderFns } from "./Setings.vue?vue&type=template&id=785e4fb4&"
import script from "./Setings.vue?vue&type=script&lang=ts&"
export * from "./Setings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports